// Tracés SVG portés tels quels de design/kit.mjs (fonction ic(), objet P).
// Grille 24×24, stroke-based. Ne pas modifier un tracé ici sans le modifier
// aussi dans les maquettes : c'est le même jeu, dans les deux systèmes.
export const ICON_PATHS = {
  grid: "M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z",
  chart: "M4 19V10M10 19V5M16 19v-6M22 19H2",
  users:
    "M16 19v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 17.5V19M10 10.5a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M20 19v-1.5a3.5 3.5 0 0 0-2.6-3.4M15.4 4.2a3.25 3.25 0 0 1 0 6.1",
  tree: "M12 3.5v3.5M12 11v3M6.5 21v-3.5M17.5 21v-3.5M6.5 17.5h11M12 14v3.5M9.5 7h5v4h-5zM4 17.5h5v3.5H4zM15 17.5h5v3.5h-5z",
  bag: "M4.5 8h15l-1.1 12H5.6zM8.5 8V6a3.5 3.5 0 0 1 7 0v2",
  cart: "M3 4h2l2.2 10.4a1.5 1.5 0 0 0 1.5 1.2h7.8a1.5 1.5 0 0 0 1.5-1.2L20 7H6M9 20.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M17 20.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
  wallet:
    "M20 8V6.5A1.5 1.5 0 0 0 18.5 5h-13A1.5 1.5 0 0 0 4 6.5v11A1.5 1.5 0 0 0 5.5 19h13a1.5 1.5 0 0 0 1.5-1.5V16M21 8h-5a2 2 0 0 0 0 8h5z",
  receipt: "M6 3h12v18l-2-1.5-2 1.5-2-1.5-2 1.5-2-1.5zM9.5 8h5M9.5 12h5",
  gift: "M4 11h16v9.5H4zM3 7.5h18V11H3zM12 7.5V21M12 7.5S10.8 4 8.8 4a2 2 0 0 0 0 3.5zM12 7.5S13.2 4 15.2 4a2 2 0 0 1 0 3.5z",
  gear: "M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4M19.4 14.5a1.5 1.5 0 0 0 .3 1.7l.1.1a1.8 1.8 0 1 1-2.6 2.6l-.1-.1a1.5 1.5 0 0 0-2.5 1v.3a1.8 1.8 0 1 1-3.6 0v-.2a1.5 1.5 0 0 0-2.6-1l-.1.1a1.8 1.8 0 1 1-2.6-2.6l.1-.1a1.5 1.5 0 0 0-1-2.5H4.5a1.8 1.8 0 1 1 0-3.6h.2a1.5 1.5 0 0 0 1-2.6l-.1-.1a1.8 1.8 0 1 1 2.6-2.6l.1.1a1.5 1.5 0 0 0 1.7.3h.1a1.5 1.5 0 0 0 .9-1.4V4.5a1.8 1.8 0 1 1 3.6 0v.2a1.5 1.5 0 0 0 2.5 1l.1-.1a1.8 1.8 0 1 1 2.6 2.6l-.1.1a1.5 1.5 0 0 0 1 2.5h.3a1.8 1.8 0 1 1 0 3.6h-.2a1.5 1.5 0 0 0-1.4.9z",
  search: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14M21 21l-4-4",
  filter: "M3.5 5.5h17l-6.6 7.7v5.6l-3.8 2.2v-7.8z",
  plus: "M12 5v14M5 12h14",
  chevR: "M9.5 5.5 16 12l-6.5 6.5",
  chevD: "m5.5 9 6.5 6.5L18.5 9",
  arrowL: "M19 12H5M11 6l-6 6 6 6",
  dots: "M12 6.2h.01M12 12h.01M12 17.8h.01",
  check: "m4.5 12.5 5 5 10-11",
  x: "M6 6l12 12M18 6 6 18",
  alert:
    "M12 8.5v4.5M12 16.5h.01M10.3 3.9 2.6 17.4a2 2 0 0 0 1.7 3h15.4a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0",
  printer:
    "M7 9V3h10v6M7 18H5.5A1.5 1.5 0 0 1 4 16.5v-5A1.5 1.5 0 0 1 5.5 10h13a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-1.5 1.5H17M7 14h10v7H7z",
  dl: "M12 3.5v11M7.5 10.5 12 15l4.5-4.5M4.5 19.5h15",
  copy: "M9 9h10.5v10.5H9zM15 9V5.5A1.5 1.5 0 0 0 13.5 4h-9A1.5 1.5 0 0 0 3 5.5v9A1.5 1.5 0 0 0 4.5 16H9",
  eye: "M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12M12 14.8a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6",
  lock: "M6 10.5h12V21H6zM8.5 10.5V7a3.5 3.5 0 0 1 7 0v3.5",
  box: "M12 3 3.5 7.5v9L12 21l8.5-4.5v-9zM3.5 7.5 12 12m0 0 8.5-4.5M12 12v9",
  up: "M3.5 16.5 9.5 10l4 4L21 6.5M15 6.5h6v6",
  down: "M3.5 7.5 9.5 14l4-4L21 17.5M15 17.5h6v-6",
  out: "M15 17.5 20 12l-5-5.5M20 12H9M11 4H5.5A1.5 1.5 0 0 0 4 5.5v13A1.5 1.5 0 0 0 5.5 20H11",
  user: "M19 20v-1.8a4.2 4.2 0 0 0-4.2-4.2H9.2A4.2 4.2 0 0 0 5 18.2V20M12 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7",
  cal: "M4 6.5h16V21H4zM4 11h16M8.5 3.5v5M15.5 3.5v5",
  refresh:
    "M20 6.5v5h-5M4 17.5v-5h5M5.2 10a7 7 0 0 1 11.6-2.8L20 11M18.8 14a7 7 0 0 1-11.6 2.8L4 13",
  clock: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M12 7v5.2l3.2 2",
  bell: "M18 9a6 6 0 1 0-12 0c0 5-2 6.5-2 6.5h16S18 14 18 9M13.7 19a2 2 0 0 1-3.4 0",
  edit: "m4 20 .8-4 11-11a1.8 1.8 0 0 1 2.6 0l1.6 1.6a1.8 1.8 0 0 1 0 2.6l-11 11z",
  trash: "M4.5 6.5h15M9.5 6.5V4.5h5v2M6.5 6.5 7.5 21h9l1-14.5M10.5 10.5v6M13.5 10.5v6",
  megaphone: "M5 9v6l13 5V4Z M5.5 15.5v2.3a1 1 0 0 0 1.4.9l.8-.4a1 1 0 0 0 .5-.9v-1.4 M20.3 7.7a7 7 0 0 1 0 8.6",
  pin: "M12 21s7-6.5 7-11.5A7 7 0 0 0 5 9.5C5 14.5 12 21 12 21z M12 12.5a2.7 2.7 0 1 0 0-5.4 2.7 2.7 0 0 0 0 5.4",
  book: "M4 6c2.5-1.2 5.2-1.2 8 0v13c-2.8-1.2-5.5-1.2-8 0zM20 6c-2.5-1.2-5.2-1.2-8 0v13c2.8-1.2 5.5-1.2 8 0z",
  help: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M9.6 9.4a2.5 2.5 0 0 1 4.8.9c0 1.7-2.4 2-2.4 3.5M12 16.8h.01",
};
